import { IDocumentDataDragParameter } from "../../../dragging";

export interface IDcoumentDataDroppableObject {
  setDroppedDocumentData(text: string, param: IDocumentDataDragParameter): void;
}

export function instanceOfIDcoumentDataDroppableObject(instance: any): instance is IDcoumentDataDroppableObject {
  return instance
    && (instance.setDroppedDocumentData !== undefined);
}
